<template>
  <div class="settleRules">
    <div class="head-box">
      <h4>
        结算政策
        <el-popover
          placement="right"
          trigger="hover"
          content="生成结算单时会匹配满足条件的结算政策"
        >
          <i class="el-icon-info f-s-12 c_gray" slot="reference"></i>
        </el-popover>
      </h4>
      <div class="c-flex">
        <el-input
          placeholder="请输入政策名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" class="m-l-10" @click="doNew">新增结算政策</el-button>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          :data="fpi.data"
          empty-text="暂无数据"
          height="calc(100% - 50px)"
          highlight-current-row
        >
          <el-table-column prop="order" label="优先级" width="80px"></el-table-column>
          <el-table-column
            prop="name"
            label="政策名称"
            width="200px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="type"
            label="结算对象"
            :formatter="formatType"
            width="140"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="sourceType"
            label="结算来源类型"
            :formatter="formatSettleSourceType"
            width="140"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="exts.billDateFieldName"
            label="业务日期"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="deductType"
            label="扣减科目"
            :formatter="formatDeductType"
            width="140"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="扣减" width="140" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.calcType == 0">{{ scope.row.calcTypeValue }}%</span>
              <span v-else>{{ scope.row.calcTypeValue }}元</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="规则生效开始日期" width="140" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.startTime || '不限制' }}
            </template>
          </el-table-column> -->
          <!-- <el-table-column label="规则生效结束日期" width="140" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.endTime || '不限制' }}
            </template>
          </el-table-column> -->
          <el-table-column
            prop="createTime"
            label="创建时间"
            width="140"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="state" label="状态">
            <template slot-scope="scope">
              <el-tag :type="scope.row.state == 1 ? '' : 'warning'">
                {{ scope.row.state == 1 ? '已启用' : '已禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row._id)">
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="结算政策" :visible.sync="openDetail" width="700px">
      <el-form
        :model="formData"
        ref="formData"
        :rules="rules"
        label-width="140px"
        label-position="left"
      >
        <el-form-item prop="order">
          <template slot="label">
            优先级
            <el-tooltip
              class="item"
              effect="dark"
              content="优先级按从高到低顺序执行"
              placement="top-start"
            >
              <i class="el-icon-question c_info"></i>
            </el-tooltip>
          </template>
          <el-input-number
            v-model="formData.order"
            :controls="false"
            :precision="0"
            :min="1"
            placeholder="优先级按从高到低顺序执行"
          ></el-input-number>
        </el-form-item>
        <el-form-item prop="name" label="政策名称">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item
          prop="memo"
          label="政策描述"
          :rules="{ required: true, trigger: 'blur', message: '政策描述不能为空' }"
        >
          <el-input v-model="formData.memo" type="textarea" :rows="1"></el-input>
        </el-form-item>
        <el-form-item
          prop="type"
          label="结算对象"
          :rules="{ required: true, trigger: ['blur', 'change'], message: '结算对象不能为空' }"
        >
          <el-select v-model="formData.type">
            <el-option
              v-for="item in options.type"
              :key="item.value"
              :label="item.label"
              :value="Number(item.value)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="sourceType"
          label="结算来源类型"
          :rules="{ required: true, trigger: ['blur', 'change'], message: '结算来源类型不能为空' }"
        >
          <el-select v-model="formData.sourceType" @change="getBillDateFields()">
            <el-option
              v-for="item in options.settleSourceType"
              :key="item.value"
              :label="item.label"
              :value="Number(item.value)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="billDateField"
          label="业务日期"
          :rules="{ required: true, trigger: ['blur', 'change'], message: '业务日期' }"
        >
          <el-select
            v-model="formData.billDateField"
            @change="billDateFieldChange"
            filterable
            allow-create
            default-first-option
            clearable
            placeholder="选项根据结算来源类型动态查询"
          >
            <el-option
              v-for="item in options.billDateFields"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <span style="float: left">{{ item.label }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">
                {{ item.value }}
              </span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="deductType"
          label="扣减科目"
          :rules="{ required: true, trigger: ['blur', 'change'], message: '扣减科目不能为空' }"
        >
          <el-select v-model="formData.deductType">
            <el-option
              v-for="item in options.deductType"
              :key="item.value"
              :label="item.label"
              :value="Number(item.value)"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item
          label="政策生效开始日期"
          prop="startTime"
          :rules="{ required: true, trigger: 'blur', message: '政策生效开始日期不能为空' }"
        >
          <el-date-picker
            v-model="formData.startTime"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
          ></el-date-picker>
        </el-form-item> -->
        <!-- <el-form-item
          prop="endTime"
          label="政策生效结束日期"
          :rules="{ required: true, trigger: 'blur', message: '政策生效结束日期不能为空' }"
        >
          <el-date-picker
            v-model="formData.endTime"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
          ></el-date-picker>
        </el-form-item> -->
        <el-form-item>
          <el-tag type="success" size="medium">多条件均满足时结算政策生效</el-tag>
        </el-form-item>
        <el-form-item
          v-for="(condition, index) of formData.paramList"
          :key="index"
          :label="'条件' + (index + 1)"
        >
          <div class="condition-card">
            <el-card shadow="hover">
              <el-form-item label="结算条件">
                <el-select
                  v-model="formData.paramList[index].name"
                  placeholder="请选择"
                  @change="
                    formData.paramList[index].value = '';
                    getOptions(formData.paramList[index].name);
                  "
                >
                  <el-option
                    v-for="item in options.settleConditions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!--按省市区-->
              <el-form-item
                v-if="formData.paramList[index].name == 'area'"
                :label="'按' + osg.codelabel('settleConditions', formData.paramList[index].name)"
                prop="area"
              >
                <el-cascader
                  :props="area.props"
                  :options="area.options"
                  v-model="formData.paramList[index].value"
                  collapse-tags
                ></el-cascader>
              </el-form-item>

              <!--按服务区域-->
              <el-form-item
                v-else-if="formData.paramList[index].name == 'serviceTerritory'"
                :label="'按' + osg.codelabel('settleConditions', formData.paramList[index].name)"
              >
                <el-select
                  v-model="formData.paramList[index].value"
                  multiple
                  filterable
                  remote
                  reserve-keyword
                  placeholder="可搜索服务区域"
                  :remote-method="getST"
                  @change="$forceUpdate()"
                >
                  <el-option
                    v-for="item in options.serviceTerritory"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <!-- 级联 -->
              <el-form-item
                v-else-if="
                  formData.paramList[index].name == 'channel' ||
                    formData.paramList[index].name == 'repairParts'
                "
                :label="'按' + osg.codelabel('settleConditions', formData.paramList[index].name)"
              >
                <el-cascader
                  :options="options[formData.paramList[index].name]"
                  v-model="formData.paramList[index].value"
                  :props="{ checkStrictly: true, multiple: true, label: 'name', emitPath: false }"
                  clearable
                ></el-cascader>
              </el-form-item>

              <el-form-item
                v-else-if="
                  formData.paramList[index].name == 'margin' ||
                    formData.paramList[index].name == 'contractAmount'
                "
                :label="'按' + osg.codelabel('settleConditions', formData.paramList[index].name)"
              >
                <el-select v-model="formData.paramList[index].value" clearable>
                  <el-option
                    v-for="item in options.operator"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-input v-model="formData.paramList[index].value"></el-input>
              </el-form-item>

              <!--按其他 字典字段-->
              <el-form-item
                v-else-if="formData.paramList[index].name == 'orgIds'"
                :label="'按' + osg.codelabel('settleConditions', formData.paramList[index].name)"
              >
                <el-select
                  v-model="formData.paramList[index].value"
                  multiple
                  clearable
                  @change="getProducts()"
                >
                  <el-option
                    v-for="item in options[formData.paramList[index].name]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <!--按其他 字典字段-->
              <el-form-item
                v-else
                :label="'按' + osg.codelabel('settleConditions', formData.paramList[index].name)"
              >
                <el-select v-model="formData.paramList[index].value" multiple clearable>
                  <el-option
                    v-for="item in options[formData.paramList[index].name]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-card>
            <div class="card-remove">
              <i class="el-icon-remove" @click="removeCondition(index)"></i>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button plain icon="el-icon-plus" class="button_dashed" @click="newCondition">
            新增条件
          </el-button>
        </el-form-item>
        <el-form-item label="计算类型">
          <div class="c-flex">
            <div>
              <el-radio :label="0" v-model="formData.calcType" @change="formData.calcTypeValue = 0">
                比例
              </el-radio>
              <template v-if="formData.calcType == 0">
                <el-input-number
                  v-model="formData.calcTypeValue"
                  :controls="false"
                  :precision="2"
                  :min="0"
                  placeholder="输入比例"
                  style="border-radius:3px 0 0 3px;"
                ></el-input-number>
                %
              </template>
            </div>
            <div class="c-m-l-15">
              <el-radio :label="1" v-model="formData.calcType" @change="formData.calcTypeValue = 0">
                定额
              </el-radio>
              <el-input-number
                v-if="formData.calcType == 1"
                v-model="formData.calcTypeValue"
                :controls="false"
                :precision="2"
                :min="0"
                placeholder="输入金额"
              ></el-input-number>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="基数类型">
          <el-radio-group v-model="formData.cardinalType">
            <el-radio
              :label="Number(item.value)"
              v-for="(item, i) in options.cardinalType"
              :key="i"
            >
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          prop="groovyScriptId"
          label="结算规则脚本"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '结算规则脚本不能为空'
          }"
        >
          <el-select v-model="formData.groovyScriptId">
            <el-option
              v-for="item in options.groovyScript"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
export default {
  name: 'SettleRules',
  data() {
    window.$this = this;
    return {
      name: 'settleRule',
      tenantId: '',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {
        paramList: [{ name: '', value: [] }],
        order: 100, //优先级
        cardinalType: 0 //结算基数类型
      },
      rules: this.$util.rules,
      options: {
        codecfg_type: { codeId: 'settleType' },
        codecfg_settleSourceType: { codeId: 'settleSourceType' }, // 结算来源类型
        codecfg_deductType: { codeId: 'deductType' }, // 扣减科目
        codecfg_settleConditions: { codeId: 'settleConditions' },
        codecfg_partnerType: { codeId: 'partnerType' },
        codecfg_operator: { codeId: 'operator' },
        // codecfg_calcType: { codeId: 'calcType' }, // 计算类型
        codecfg_cardinalType: { codeId: 'cardinalType' } // 基数类型
      },
      area: {
        props: {
          multiple: true
        },
        options: this.osg.areaList
      }
    };
  },
  mounted() {
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
    this.doInit();
    this.getGroovyScripts();
    this.osg.codeoption(() => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    formatType(row, column, cellValue) {
      return this.osg.codelabel('type', cellValue);
    },
    formatSettleSourceType(row, column, cellValue) {
      return this.osg.codelabel('settleSourceType', cellValue);
    },
    formatDeductType(row, column, cellValue) {
      return this.osg.codelabel('deductType', cellValue);
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        paramList: [{ name: '', value: [] }],
        order: 100, //优先级
        cardinalType: 0, //结算基数类型
        exts: {}
      };
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'in:state|array-integer#and': '0,1',
        sortField: 'deductType,order',
        sortOrder: 'desc',
        'regex:name|string#or': this.searchValue
      };
      //添加过滤器参数
      $that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('biz/settleRule/query.do', params, res => {
        res.paramList = [];
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      this.formData = row;
      this.getBillDateFields(true);
      for (let condition of row.paramList) {
        this.getOptions(condition.name);
      }
      this.openDetail = true;
    },
    doSave() {
      if (this.osg.validate()) {
        if (this.formData.startTime && this.formData.endTime) {
          if (
            new Date(this.formData.startTime).getTime() > new Date(this.formData.endTime).getTime()
          ) {
            this.osg.alert('开始日期不能大于结束日期');
            return;
          }
          this.formData.startTime = this.formData.startTime + ' 00:00:00';
          this.formData.endTime = this.formData.endTime + ' 23:59:59';
        } else {
          //TODO:写死的默认时间
          this.formData.startTime = '2019-01-01 00:00:00';
          this.formData.endTime = '3019-01-01 00:00:00';
        }

        this.osg.ajax(
          'biz/settleRule/upsert.do',
          { data: JSON.stringify(this.formData) },
          () => {
            this.osg.toast('保存成功');
            this.doInit();
            this.getData();
          },
          {
            noload: true
          }
        );
      }
    },
    doEnable(id) {
      this.osg.ajax(`biz/settleRule/enable/${id}.do`, null, () => {
        this.osg.toast('启用成功');
        this.getData();
      });
    },
    doDisable(id) {
      this.osg.ajax(`biz/settleRule/disable/${id}.do`, null, () => {
        this.osg.toast('禁用成功');
        this.getData();
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax(`biz/settleRule/remove/${id}.do`, null, () => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    // 新增条件
    newCondition() {
      this.formData.paramList.push({
        name: '',
        value: []
      });
    },
    // 删除条件
    removeCondition(index) {
      this.formData.paramList.splice(index, 1);
    },
    // 获取字典表
    getOptions(type) {
      if (type == 'orgIds') {
        this.getOrgs();
      } else if (type == 'partnerIds') {
        this.getPartners();
      } else if (type == 'productIds') {
        this.getProducts();
      } else if (type == 'serviceTerritory') {
        this.getST();
      } else if (type == 'workType') {
        this.getWorkType();
      } else if (type == 'area') {
        // console.log('area');
      } else {
        // 字典表选项
        if (type == 'channel' || type == 'repairParts') {
          this.options['cascadeCode_' + type] = {
            codeId: type
          };
        } else {
          this.options['codecfg_' + type] = { codeId: type };
        }
        this.osg.codeoption(() => {
          this.$forceUpdate();
        });
      }
    },
    // 获取服务区域
    getST(query) {
      this.osg.ajax(
        'basic/serviceTerritory/query.do',
        {
          _all: '1',
          'in:state|array-integer#and': '1',
          'regex:name|string#or': query,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.serviceTerritory = res.data;
          this.$forceUpdate();
        }
      );
    },
    // 获取伙伴
    getOrgs() {
      this.osg.ajax(
        'org/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.orgList.map(item => {
            item.label = item.orgName;
            item.value = item._id;
          });
          this.options.orgIds = res.data.orgList;
          this.$forceUpdate();
        }
      );
    },
    // 获取伙伴
    getPartners() {
      this.osg.ajax(
        'basic/partner/query.do',
        {
          _all: '1',
          'in:state|array-integer#and': '1',
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.partnerIds = res.data;
          this.$forceUpdate();
        }
      );
    },
    // 获取产品
    getProducts() {
      let params = {
        _all: '1',
        'in:state|array-integer#and': '1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };

      // 当选择指定门店时，指定产品只能选择门店可用的产品
      let paramList = this.formData.paramList;
      let orgIds = [];
      for (let item of paramList) {
        if (item.name == 'orgIds' && this.tenantId != '1340835581184723420') {
          orgIds.push(item.value);
        }
      }
      if (orgIds.length > 0) params['in:orgId|array#and'] = orgIds.toString();

      this.osg.ajax('basic/product/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.productIds = res.data;
        this.$forceUpdate();
      });
    },
    // 获取工作类型
    getWorkType(query) {
      this.osg.ajax(
        'biz/workType/query.do',
        {
          _all: '1',
          'in:state|array-integer#and': '1',
          'regex:name|string#or': query,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.workType = res.data;
          this.$forceUpdate();
        }
      );
    },
    //获取结算类型groovyScript
    getGroovyScripts() {
      this.osg.ajax(
        'groovyScript/query.do',
        {
          _all: '1',
          'is:type|integer#and': 2, //结算类型脚本
          'in:state|array-integer#and': '1',
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.groovyScript = res.data;
          this.$forceUpdate();
        }
      );
    },
    // 根据结算来源类型（工单、订单、合同），动态展示该对象中时间类型的字段
    getBillDateFields(edit) {
      // 清除原值（除编辑时）
      if (this.formData.billDateField && !edit) {
        this.formData.billDateField = '';
      }
      this.options.billDateFields = [];

      // 查询选项
      let colName;
      switch (this.formData.sourceType) {
        case 0:
          colName = 'serviceAppointment';
          break;
        case 1:
          colName = 'order';
          break;
        case 2:
          colName = 'contract';
          break;
        default:
      }
      if (colName) {
        this.osg.ajax(
          'biz/extField/query.do',
          {
            colName,
            _all: '1',
            'is:state|integer#and': 1,
            sortField: 'order',
            sortOrder: 'asc',
            'in:type|array#and': 'date,time,datetime'
          },
          res => {
            res.data.map(item => {
              item.label = item.nameDisp;
              item.value = item.name;
            });
            this.options.billDateFields = res.data;
            this.$forceUpdate();
          }
        );
      }
    },
    // 冗余存billDateField的中文名称
    billDateFieldChange(value) {
      this.formData.exts = this.formData.exts || {};
      let billDateFieldName = '';
      if (value) {
        let arr = this.options.billDateFields || [];
        for (let item of arr) {
          if (item.value == value) {
            billDateFieldName = item.label;
            break;
          }
        }
      }
      this.formData.exts.billDateFieldName = billDateFieldName || value;
    }
  }
};
</script>
<style>
.settleRules .el-dialog__body {
  padding: 20px 30px;
}
.settleRules .el-radio {
  display: inline !important;
}
.calc-value .el-form-item__content {
  display: flex;
}
</style>
